(function () {
	var bootstrapped = false;
	var retried = false;

	var initGallery = function (root) {
		if (!root || root.dataset.galleryReady === "true" || typeof Swiper === "undefined") {
			return;
		}

		var swiperEl = root.querySelector(".physical-store-gallery__swiper");
		if (!swiperEl || swiperEl.swiper) {
			return;
		}

		var slides = swiperEl.querySelectorAll(".swiper-slide");
		if (!slides.length) {
			return;
		}

		var perView = function (preferred) {
			return Math.min(preferred, slides.length);
		};

		root.dataset.galleryReady = "true";

		new Swiper(swiperEl, {
			slidesPerView: 1,
			spaceBetween: 16,
			speed: 450,
			rewind: slides.length > 1,
			watchOverflow: true,
			observer: true,
			observeParents: true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			a11y: {
				prevSlideMessage: root.dataset.prevLabel || "Previous photo",
				nextSlideMessage: root.dataset.nextLabel || "Next photo",
			},
			navigation: {
				nextEl: root.querySelector("[data-gallery-next]"),
				prevEl: root.querySelector("[data-gallery-prev]"),
			},
			pagination: {
				el: root.querySelector("[data-gallery-pagination]"),
				clickable: true,
			},
			breakpoints: {
				750: {
					slidesPerView: perView(2),
					spaceBetween: 16,
				},
				990: {
					slidesPerView: perView(3),
					spaceBetween: 24,
				},
			},
		});
	};

	var boot = function () {
		if (typeof Swiper === "undefined") {
			return;
		}

		document.querySelectorAll("[data-physical-store-gallery]").forEach(initGallery);
	};

	var start = function () {
		if (typeof Swiper === "undefined") {
			if (!retried) {
				retried = true;
				window.addEventListener("load", start, { once: true });
			}
			return;
		}

		if (bootstrapped) {
			boot();
			return;
		}

		bootstrapped = true;
		boot();

		document.addEventListener("shopify:section:load", function (event) {
			if (!event.target) {
				return;
			}

			event.target.querySelectorAll("[data-physical-store-gallery]").forEach(function (root) {
				delete root.dataset.galleryReady;
				initGallery(root);
			});
		});

		document.addEventListener("shopify:section:unload", function (event) {
			if (!event.target) {
				return;
			}

			event.target.querySelectorAll(".physical-store-gallery__swiper").forEach(function (swiperEl) {
				if (swiperEl.swiper) {
					swiperEl.swiper.destroy(true, true);
				}
			});
		});
	};

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
})();
